export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:4000',
    ENDPOINTS: {
        REGISTER: '/auth/register',
        FORGOT_PASSWORD: '/auth/forgot-password',
        ADMIN_LOGIN: '/auth/web/login',
        LOGIN_WITH_TOKEN: '/auth/login-with-token',
        GET_USERS: '/admin/users',
        GET_USER_BY_ID: '/admin/users',
        UPDATE_USER_STATUS: '/admin/users',
        REFRESH_TOKEN: '/auth/refresh',
        LOGOUT: '/auth/logout',
        VALIDATE_REFERRAL: '/referral/validate',
        GET_PLANS: '/stripe/plans',
        CREATE_ONE_TIME_PAYMENT: '/stripe/payment/one-time',
        VERIFY_FREE_BAND_CODE: '/free-band/verify-code',
        CREATE_FREE_BAND_ORDER: '/free-band/order',
    },
    TIMEOUT: 10000
};